import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

export const live: AppRouteModule = {
  path: '/live',
  name: 'live',
  component: LAYOUT,
  redirect: '/live/edit',
  meta: {
    hideChildrenInMenu: false,
    icon: 'simple-icons:about-dot-me',
    title: t('routes.dashboard.about'),
    orderNo: 100000,
  },
  children: [
    {
      path: 'edit',
      name: 'edit',
      meta: {
        hideMenu: false,
        title:  '编辑直播',
      },
      component: () => import('/@/views/liveManagement/edit.vue'),
    },
  ],
};
